import React from 'react';
import { useState, useEffect } from 'react';
import "./InputFile.css"
import InputFileElement from "./InputFileElement"

function InputFile({ onChange, value }) {
  const [lastId, setLastId] = useState(0);
  const [InputsArray, setInputsArray] = useState([lastId]);
  const [files, setFiles] = useState([]);

  useEffect(() => {
    if (value.length === 0) {
      setInputsArray([0])
      setLastId(0)
    }
  }, [value])

  return (
    <div>
      {InputsArray.map(index => <InputFileElement value={value} createNewInputCallback={createNewInput} removeInputCallback={removeInput} key={index} returnKey={index} />)}
    </div>
  )

  function createNewInput(file) {
    setInputsArray([...InputsArray, lastId + 1])
    setLastId(lastId + 1);

    let updatedFiles = [...files]
    updatedFiles[lastId] = file;
    setFiles(updatedFiles)
    onChange(updatedFiles)
  }

  function removeInput(index) {
    setInputsArray(InputsArray.filter(item => item !== index))

    let updatedFiles = files.filter((f, i) => i !== index)
    setFiles(updatedFiles)
    onChange(updatedFiles)
  }
}

export default InputFile;